<template>
    <div>
        <div class='mcf-page-background'></div>
        <div class="mcf-page-editor">
            <div class="mcf-page-editor-form">
                <div class="mcf-page-editor-header">
                    <label>Sélection du client</label>
                </div>
                <div class="mcf-page-editor-menu">
                    <div class="mcf-page-editor-menu-search">
                        <input v-model="txtsearch" type="text" placeholder="Rechercher">
                    </div>
                    <button style="position:absolute;right:10px;" @click="bt_cancel">
                        <i class="fa fa-close"></i>
                        <label>Annuler</label>
                    </button>
                </div>
                <div style="padding:0px;" class="mcf-page-editor-content">
                    <div v-for="c of list" :key="c.id" class="mcf-page-editor-line-item">
                        <div class="mcf-page-editor-line-item-content">
                            <label style="font-weight: bold;color:var(--C2);">{{c.company}}</label>
                            <label>{{c.address1}}</label>
                            <label>{{c.zipcode}} {{c.city}}</label>
                        </div>
                        <div class="mcf-page-editor-line-item-icon">
                            <button class="mcf-button" @click="bt_select(c)" v-if="c.is_inactive==0">Sélectionner</button>
                            <button class="mcf-button-disabled" v-if="c.is_inactive==1">Bloqué</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import {DateTime} from "luxon";
import apicustomer from "../data/customer";

export default {
    props:{
        account:Object,
        cancel:Function,
        select:Function
    },
    data(){
        return {
            txtsearch:'',
            customers:[]
        };        
    },
    computed: {
        list:function(){
            var tmain = this;
            var l = [];
            // var monRegEx = /^[a-zA-Z0-9áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ._\s-]{5,60}$/;
            var txt = tmain.txtsearch.toLowerCase();
            l = tmain.customers.filter(x=>x.company.toLowerCase().indexOf(txt)>-1 || x.address1.toLowerCase().indexOf(txt)>-1 || x.zipcode.toLowerCase().indexOf(txt)>-1 || x.city.toLowerCase().indexOf(txt)>-1);
            return l;
        }
    },
    created: async function() {
        var tmain = this;
        var pkg = await apicustomer.list();
        if (pkg.code==0){
            tmain.customers = pkg.data;
        }
    },
    methods:{
        bt_cancel:function(){
            this.cancel();
        },
        bt_select:function(customer){
            if (customer.is_inactive==0){
                this.select(customer);
            }            
        }
    }
}
</script>